import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import * as Yup from "yup";
import {
  CheckConfirm,
  CheckUserExistByMobile,
  SendConfirm,
} from "../../services/AccountService";
import toast from "react-hot-toast";
import { Button } from "primereact/button";
import {
  GetInvitationByInvitationId,
  UpdateInvitation,
} from "../../services/InvitationService";
import {
  GetLastCodeConfirm,
  SendConfirmationCode,
} from "../../services/CommiunicationService";
import { log } from "@grpc/grpc-js/build/src/logging";
import { useDispatch } from "react-redux";
import { fetchUserProfile } from "../../features/profile/profileSlice";
const InvitationRequestConfirmUser = () => {
  const params = useParams();
  const setActiveIndex = useOutletContext();
  const [getPhoneNumberDisabled, SetPhoneNumberDisabled] = useState(false);
  const [getInvitation, SetInvitation] = useState(false);
  const [visible, setVisible] = useState(false);
  const [getInvitationData, SetInvitationData] = useState<any>(null);

  const navigate = useNavigate();
  const Ref = useRef(null);
  const [getVerificationStatusCode, SetVerificationStatusCode] = useState(null);
  const formikConfirm = useFormik({
    initialValues: {
      phoneNumber: "",
      code: "",
    },
    validationSchema: Yup.object().shape({
      phoneNumber: Yup.string()
        .required("لطفا شماره تلفن همراه خود را وارد کنید")
        .length(11, "شماره تلفن همراه در فرمت صحیح خود نمیباشد"),
      code: Yup.string().required("لطفا کد تایید را وارد کنید"),
    }),
    onSubmit: (values) => {
      GetLastCodeConfirmAsync(values.phoneNumber, values.code);
    },
  });
  const [getNewUser, SetNewUser] = useState(false);

  async function CheckUserExistByMobileAsync() {
    await CheckUserExistByMobile(getInvitationData.phoneNumber).then((p) => {
      if (p.data.statusCode === 200) {
        SetNewUser(false);
      } else {
        SetNewUser(true);
      }
    });
  }

  const dispatch = useDispatch<any>();

  const CheckConfirmAsync = async (input: any) => {
    try {
      console.log(formik.values.phoneNumber);
      console.log(input.code);

      await CheckConfirm(formik.values.phoneNumber, input.code, 0).then((p) => {
        if (p.status === 200) {
          localStorage.setItem("token", p.data.data.token);
          dispatch(fetchUserProfile()).then(() => {
            (setActiveIndex as any)(1);
          });
          navigate(`/ViewInvitation/InvitationRequest/${params.id}`);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  async function GetLastCodeConfirmAsync(phoneNumber: string, code: string) {
    await GetLastCodeConfirm(phoneNumber, code).then((p) => {
      if (p.data.statusCode !== 200) {
        toast.error(p.data.message);
      } else {
        (setActiveIndex as any)(1);
        UpdateInvitationAsync();
        if (getNewUser) {
          navigate(`/ViewInvitation/InvitationPassword/${params.id}`);
        } else {
          //navigate(`/ViewInvitation/InvitationRequest/${params.id}`);
          CheckConfirmAsync({ phoneNumber: phoneNumber, code: code });
        }
      }
    });
  }

  async function UpdateInvitationAsync() {
    await UpdateInvitation({ invitationId: params.id, invitationState: 1 });
  }

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: Yup.object().shape({
      phoneNumber: Yup.string()
        .required("لطفا شماره تلفن همراه خود را وارد کنید")
        .length(11, "شماره تلفن همراه در فرمت صحیح خود نمیباشد"),
    }),
    onSubmit: (values) => {
      //console.log(values);
      formikConfirm.setFieldValue("phoneNumber", values.phoneNumber);
      postConfirm(values);
    },
  });

  // The state for our timer
  const [timer, setTimer] = useState("00:00");
  const [showTimer, setShowTimer] = useState(false);
  const getTimeRemaining = (e: any) => {
    const total = Date.parse(e) - Date.parse(new Date().toString());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    if (seconds === 0 && minutes === 0) {
      setShowTimer(false);
      SetPhoneNumberDisabled(false);
    }
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e: any) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      setTimer(
        // (hours > 9 ? hours : "0" + hours) +
        // 	":" +
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    }
  };
  const postConfirm = async (input: any) => {
    try {
      console.log(input.phoneNumber);
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        },
      };
      const data = await SendConfirmationCode({
        phoneNumber: input.phoneNumber,
      }).then(function (response) {
        console.log(response);
        if (response.data.statusCode === 400) {
          toast.error(response.data.message);
        } else {
          if (showTimer) return;
          setShowTimer(true);
          SetPhoneNumberDisabled(true);
          clearTimer(getDeadTime());
        }
      });
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const clearTimer = (e: any) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    setTimer("01:00");

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id as any;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 60);
    return deadline;
  };

  // We can use useEffect so that when the component
  // mount the timer will start as soon as possible

  // We put empty array to act as componentDid
  // mount only

  // Another way to call the clearTimer() to start
  // the countdown is via action event from the
  // button first we create function to be called
  // by the button
  async function GetInvitationByInvitationIdAsync() {
    await GetInvitationByInvitationId(params.id).then((p) => {
      console.log(p.data.data);
      if (p.data.data === undefined || p.data.data === null) {
        navigate("/InvitationNotFound");
      }
      SetInvitationData(p.data.data);
    });
  }
  useEffect(() => {
    GetInvitationByInvitationIdAsync();
  }, []);
  useEffect(() => {
    if (getInvitationData?.phoneNumber) {
      formik.setFieldValue("phoneNumber", getInvitationData.phoneNumber);
    }
    if (getInvitationData) {
      CheckUserExistByMobileAsync();
    }
  }, [getInvitationData]);
  return (
    <>
      <div className="container mt-5 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
        <p>کد تاییدی به شماره همراه شما ارسال خواهد شد</p>
        <div className="pt-3 col-12 px-2">
          <span className="p-float-label">
            <InputText
              value={
                getInvitationData?.phoneNumber?.substring(
                  getInvitationData?.phoneNumber?.length - 2
                ) +
                "*****" +
                getInvitationData?.phoneNumber?.substring(0, 4)
              }
              disabled={getPhoneNumberDisabled}
              //{...formik.getFieldProps("phoneNumber")}
              id="phoneNumber"
              //keyfilter="num"
              type="text"
              style={{ width: "100%" }}
            />
            <label style={{ right: "10px", left: "unset" }} htmlFor="username">
              تلفن همراه
            </label>
            {showTimer ? (
              <span
                style={{
                  left: "10px",
                  position: "absolute",
                  top: "25%",
                  color: "green",
                  cursor: "pointer",
                }}>
                {timer}
              </span>
            ) : (
              <Button
                onClick={formik.submitForm}
                label="دریافت کد تایید"
                style={{
                  left: "0px",
                  position: "absolute",
                  top: "0%",
                  borderRadius: "8px 0px 0px 8px",
                  cursor: "pointer",
                }}
                className="p-button-success"
              />
            )}

            {/* <span
								onClick={onClickReset}
								style={{
									left: "10px",
									position: "absolute",
									top: "25%",
									color: "green",
									cursor: "pointer",
								}}>
								
							</span> */}
          </span>
          {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
            <b style={{ fontSize: "0.65rem" }} className="my-1 text-danger">
              {formik.errors.phoneNumber}{" "}
            </b>
          ) : null}
        </div>
        <div
          className={`${showTimer ? "" : "d-none"} ${"col-12 mt-4 px-2"}`}
          style={{ width: "100%" }}>
          <span className="p-float-label" style={{ width: "100%" }}>
            <InputText
              {...formikConfirm.getFieldProps("code")}
              id="code"
              keyfilter="num"
              dir="ltr"
              style={{ width: "100%" }}
            />
            <label style={{ right: "10px", left: "unset" }} htmlFor="password">
              کد تایید
            </label>
          </span>
          {formikConfirm.touched.code && formikConfirm.errors.code ? (
            <b style={{ fontSize: "0.65rem" }} className="my-1 text-danger">
              {formikConfirm.errors.code}{" "}
            </b>
          ) : null}
        </div>
        <div
          className={`${showTimer ? "" : "d-none"} ${"col-12 mt-4 px-2"}`}
          style={{ width: "100%" }}>
          <Button
            label="ادامه"
            // disabled={showTimer ? false : true}
            style={{ width: "100%" }}
            onClick={formikConfirm.submitForm}
            className="mt-3 p-button-info"></Button>
        </div>
      </div>
    </>
  );
};
export default InvitationRequestConfirmUser;
